<template>
  <v-slide-y-transition>
    <v-system-bar v-if="showTotpBanner" class="text-body-2 black--text totp-notification" color="warning" app height="36">
      <v-container class="align-center d-flex justify-center">
        {{ $t('texts.enable2FaToSecureYourAccount') }}

        <v-btn
          v-if="Boolean(accountUrl)"
          class="ml-4"
          outlined
          small
          :href="accountUrl"
          size="small"
          target="_blank"
          color="black"
        >
          {{ $t('texts.activate') }}
          <v-icon
            right
            color="black"
            small
          >
            mdi-open-in-new
          </v-icon>
        </v-btn>
      </v-container>
    </v-system-bar>
  </v-slide-y-transition>
</template>

<script lang="ts" setup>
import { useKeycloak } from '@/helpers/keycloak';
import { computed, ref } from 'vue';

const keycloak = useKeycloak();

const accountUrl = ref(keycloak.createAccountUrl());

const showTotpBanner = computed(() => keycloak?.tokenParsed && !keycloak.tokenParsed.totp);
</script>

<style lang="css" scoped>
@media print {
  .totp-notification{
    display: none;
  }
}
</style>
